export default __webpack_public_path__ + "static/media/news2.dfef375e.webp";